var React = require('react');

function NavIcon (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"x":"20","y":"29","width":"30","height":"2","fill":"white","key":0}),React.createElement("rect",{"x":"30","y":"39","width":"20","height":"2","fill":"white","key":1})]);
}

NavIcon.defaultProps = {"width":"70","height":"70","viewBox":"0 0 70 70","fill":"none"};

module.exports = NavIcon;

NavIcon.default = NavIcon;
